import React, {useEffect, useRef} from "react"

import LegacyImage from "components/LegacyImage"
import {legacyImageURL} from "components/LegacyImage"
import ReactCompareImage from "steps/shared/ReactCompareImage"
import { useIntersectionObserver } from 'hooks/useIntersectionObserver'
import { ListicleContent } from 'steps/listicle/ListicleStep3'

/*

*/

const ArticleContent = ({article, onGotToBottom}) => {

    const articleBottomRef = useRef();
    const [inView, entry] = useIntersectionObserver(articleBottomRef, {
        threshold: 0.1
    });

    useEffect(() => {
        if (inView && onGotToBottom) {
            onGotToBottom()
        }
    }, [inView]);



    const articleContent = article.contents.map((x, i) => {
        const TODO_FIX_THIS = undefined
        return <ListicleContent step={TODO_FIX_THIS} content={x} key={i} />
      if (x["leftImage"]) {
        return (
            <ReactCompareImage key={i} leftImage={legacyImageURL(x.leftImage)} rightImage={legacyImageURL(x.rightImage)} />
          )
      }
        if (x["buttonText"]) {
          return (
            <div style={{}} className="custom-btn-container" key={i} >
              <a className="btn btn-custom" style={{color: `${x.textColor}`,background: `${x.bgColor}`}} href={x["url"]}>{x.buttonText}</a>
            </div>
            )
        }
        if (x["blockQuote"]) {
          return (
              <div className="blockquote" key={i} >
               <i className="fas fa-quote-left"></i>
                  <span dangerouslySetInnerHTML={{__html: x["blockQuote"]}} />
                  <i className="fas fa-quote-right"></i>
                <span className="source" dangerouslySetInnerHTML={{__html: x["blockQuoteSource"]}} />
              </div>
            )
        }
        if (x["subHead"]) {
          return <h3 className="content-item subhead" dangerouslySetInnerHTML={{__html: x["subHead"]}} key={i} />
        }
        if (x["image"]) {
          return  (
            <div key={i} className="image-contain"
            style={{width:`${x.scaling}%`}}>
              <LegacyImage  image={x.image} key={i} />
            </div>
          )
        }
        if (x["bodyCopy"]) {
            // The editorial team hard-coded some sign-up copy in many/most articles. This removes it.
            let tmp = x["bodyCopy"]
            const reg = /(\bNot a member\b(.*)\bfamily and friends\b\!)/
            tmp = tmp.replace(reg, "")

            return <p dangerouslySetInnerHTML={{__html: tmp}} key={i} />
        }
        if (x["embedCode"]) {
          return <p dangerouslySetInnerHTML={{__html: x["embedCode"]}} key={i} />
        }
        return null
      }
    )

    // add social media scripts on load
    useEffect(() => {
      const tikTokScript = document.createElement('script');
      const instagramScript = document.createElement('script');
      const twitterScript = document.createElement('script');

      tikTokScript.src = "https://www.tiktok.com/embed.js";
      tikTokScript.async = true;

      instagramScript.src = "https://platform.instagram.com/en_US/embeds.js";
      instagramScript.async = true;

      twitterScript.src = "https://platform.twitter.com/widgets.js";
      twitterScript.async = true;

      document.body.appendChild(tikTokScript);
      document.body.appendChild(instagramScript);
      document.body.appendChild(twitterScript);

      return () => {
        document.body.removeChild(tikTokScript);
        document.body.removeChild(instagramScript);
        document.body.removeChild(twitterScript);
      }
    }, []);

    return (
        <>
            <div className="content">{ articleContent }</div>
            <div ref={articleBottomRef}></div>   {/* use Intersection Observer to look for this div to know that the user scrolled to the end */}
        </>
    )
  }

export default ArticleContent